import app from 'firebase/app'
import 'firebase/auth'
import 'firebase/firebase-firestore'
import 'firebase/storage';

const config = {
    apiKey: "AIzaSyBmX75jVeSqePe3ff067hSoymIic9j15ZE",
    authDomain: "aforo-bjj.firebaseapp.com",
    databaseURL: "https://aforo-bjj.firebaseio.com",
    projectId: "aforo-bjj",
    storageBucket: "aforo-bjj.appspot.com",
    messagingSenderId: "296053731824",
    appId: "1:296053731824:web:aca7db405fed11c201ed35",
    measurementId: "G-4Y7ZRT5BGK"
}

class Firebase {
	constructor() {
		app.initializeApp(config)
		this.auth = app.auth()
		this.db = app.firestore()
		this.storage = app.storage();
		this.batch = this.db.batch()
	}

	login(email, password) {
		return this.auth.signInWithEmailAndPassword(email, password)
	}

	logout() {
		return this.auth.signOut()
	}

	async register(name, email, password) {
		await this.auth.createUserWithEmailAndPassword(email, password)
		return this.auth.currentUser.updateProfile({
			displayName: name
		})
	}

	isInitialized() {
		return new Promise(resolve => {
			this.auth.onAuthStateChanged(resolve)
		})
	}

	getCurrentUsername() {
		if(this.auth.currentUser ){
			return [{
				name: this.auth.currentUser.displayName,
				uid: this.auth.currentUser.uid,
				email: this.auth.currentUser.email
			}]
		}
	}

	forgetPass(email){
		return this.auth.sendPasswordResetEmail(email)
	}
}

export default new Firebase()